// extracted by mini-css-extract-plugin
export var background = "_ih-6";
export var containerMedium = "_ih-0";
export var containerMicro = "_ih-2";
export var containerSmall = "_ih-1";
export var dropdown = "_ih-5";
export var dropdownLabel = "_ih-a";
export var enter = "_ih-7";
export var exitActive = "_ih-8";
export var label = "_ih-3";
export var option = "_ih-9";
export var select = "_ih-4";